/**
 * PERSO: compteur de produits du bandeau d'en-tête (sections/perso-entete-page.liquid).
 * Quand le visiteur filtre, Horizon ne re-rend que la section de la grille : le bandeau, lui, garde
 * le nombre du chargement initial. Le compteur se recale donc sur l'attribut data-results-count que
 * la grille filtrée porte déjà, en surveillant la section qui la contient.
 * Sans filtres sur la page, ou sans JavaScript, le nombre rendu par Liquid reste affiché.
 */

class PersoEnteteCompteur extends HTMLElement {
  /** @type {MutationObserver | undefined} */
  #observateur;

  /** @type {number | undefined} */
  #image;

  connectedCallback() {
    const surveille = this.#sectionDeLaGrille();
    if (!surveille) return;

    this.#observateur = new MutationObserver(this.#planifier);
    this.#observateur.observe(surveille, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-results-count'],
    });
  }

  disconnectedCallback() {
    this.#observateur?.disconnect();
    this.#observateur = undefined;
    if (this.#image) cancelAnimationFrame(this.#image);
  }

  /**
   * La section qui porte le nombre de résultats. Son contenu est remplacé à chaque filtrage,
   * c'est donc elle qu'il faut surveiller, pas l'élément compté lui-même.
   * @returns {Element | null}
   */
  #sectionDeLaGrille() {
    const porteur = document.querySelector('[data-results-count]');
    return porteur?.closest('.shopify-section') ?? null;
  }

  /** Plusieurs mutations arrivent d'affilée : une seule mise à jour par image suffit. */
  #planifier = () => {
    if (this.#image) cancelAnimationFrame(this.#image);
    this.#image = requestAnimationFrame(() => {
      this.#image = undefined;
      this.#mettreAJour();
    });
  };

  #mettreAJour() {
    const porteur = document.querySelector('[data-results-count]');
    if (!(porteur instanceof HTMLElement)) return;

    const nombre = Number(porteur.dataset.resultsCount);
    if (!Number.isFinite(nombre)) return;

    if (nombre <= 0) {
      this.textContent = '';
      return;
    }

    const un = this.dataset.modeleUn || '';
    const plusieurs = this.dataset.modelePlusieurs || '';
    this.textContent = nombre === 1 ? un : plusieurs.replace('__N__', String(nombre));
  }
}

if (!customElements.get('perso-entete-compteur')) {
  customElements.define('perso-entete-compteur', PersoEnteteCompteur);
}
